import React from "react";
import { sortBy } from "lodash";
import { db } from "../services/firebase";
import { Field, reduxForm } from "redux-form";
import { FormGroup, Row, Col } from "react-bootstrap";
import Button from "../elements/CustomButton/CustomButton.jsx";
import { renderSelect } from "./_fieldRenderer";

import "./forms.css";

const validate = (values) => {
  const errors = {};
  if (!values.product) {
    errors.product = "Obrigatório";
  }
  if (!values.indicator) {
    errors.indicator = "Obrigatório";
  }
  return errors;
};

class ScreenForm extends React.Component {
  constructor(props) {
    super(props);
    this.companyID = props.companyID;

    this.state = {
      products: [],
      indicators: [],
      places: [],
      lines: [],
      tables: [],
      fetchingProducts: false,
      fetchingIndicators: false,
      fetchingPlaces: false,
      fetchingLines: false,
      fetchingTables: false,
    };
  }

  componentDidMount() {
    this._fetchProducts();
    this._fetchPlaces();
    this._fetchLines();
    this._fetchTables();
  }

  render() {
    const { handleSubmit, submitting, change } = this.props;
    const {
      products,
      indicators,
      lines,
      tables,
      places,
      fetchingProducts,
      fetchingIndicators,
      fetchingLines,
      fetchingTables,
      fetchingPlaces,
    } = this.state;

    return (
      <form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Field
                name="product"
                component={renderSelect}
                label="Produto"
                disabled={!products.length}
                placeholder={this._handlePlaceholder(products)(
                  fetchingProducts
                )("male")}
                options={sortBy(products, ["label", "asc"])}
                onChange={(e, newValue) => {
                  change("indicator", null);
                  //eslint-disable-next-line
                  newValue ? this._fetchIndicators(newValue) : null;
                }}
              />
            </FormGroup>
          </Col>

          <Col md={6}>
            <FormGroup>
              <Field
                name="indicator"
                component={renderSelect}
                label="Indicador"
                disabled={!indicators.length}
                placeholder={this._handlePlaceholder(indicators)(
                  fetchingIndicators
                )("male")}
                options={sortBy(indicators, ["label", "asc"])}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <FormGroup>
              <Field
                name="place"
                component={renderSelect}
                label="Local"
                optional
                disabled={!places.length}
                placeholder={this._handlePlaceholder(places)(fetchingPlaces)(
                  "male"
                )}
                options={sortBy(places, ["label", "asc"])}
              />
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Field
                name="line"
                component={renderSelect}
                label="Linha"
                optional
                disabled={!lines.length}
                placeholder={this._handlePlaceholder(lines)(fetchingLines)(
                  "female"
                )}
                options={sortBy(lines, ["label", "asc"])}
              />
            </FormGroup>
          </Col>

          <Col md={4}>
            <FormGroup>
              <Field
                name="table"
                component={renderSelect}
                label="Mesa"
                optional
                disabled={!tables.length}
                placeholder={this._handlePlaceholder(tables)(fetchingTables)(
                  "female"
                )}
                options={sortBy(tables, ["label", "asc"])}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row className="form__actions_margin">
          <div className="form__actions_container">
            <Button
              style={{ width: "45%" }}
              bsStyle="danger"
              type="button"
              disabled={submitting}
              onClick={this._handleCancel}
              wd
            >
              Cancelar
            </Button>
            <Button
              style={{ width: "45%" }}
              bsStyle="default"
              type="submit"
              disabled={submitting}
              fill
            >
              Adicionar
            </Button>
          </div>
        </Row>
      </form>
    );
  }

  //products fetch
  _fetchProducts = () => {
    const products = [];
    this.setState({ fetchingProducts: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("products")
      .get()
      .then((productSnapshot) => {
        if (!productSnapshot.empty) {
          productSnapshot.forEach((product) =>
            products.push({
              value: product.id,
              label: `${product.data().name}`,
            })
          );
          this.setState({ fetchingProducts: false, products });
        } else {
          this.setState({ fetchingProducts: false, products });
        }
      })
      .catch((e) => console.log(e));
  };

  //products fetch dependant
  _fetchIndicators = (newValue) => {
    const indicators = [];
    this.setState({ fetchingIndicators: true, indicators });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("indicators")
      .where("product", "==", newValue.value)
      .get()
      .then((indicatorSnapshot) => {
        if (!indicatorSnapshot.empty) {
          indicatorSnapshot.forEach((indicator) =>
            indicators.push({
              value: indicator.id,
              label: `${indicator.data().name}`,
            })
          );
          this.setState({ fetchingIndicators: false, indicators });
        } else {
          this.setState({ fetchingIndicators: false, indicators });
        }
      })
      .catch((e) => console.log(e));
  };

  //optionals
  _fetchPlaces = () => {
    const places = [];
    this.setState({ fetchingPlaces: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("places")
      .get()
      .then((placeSnapshot) => {
        if (!placeSnapshot.empty) {
          placeSnapshot.forEach((place) =>
            places.push({
              value: place.id,
              label: `${place.data().name}`,
            })
          );
          this.setState({ fetchingPlaces: false, places });
        } else {
          this.setState({ fetchingPlaces: false, places });
        }
      })
      .catch((e) => console.log(e));
  };

  _fetchLines = () => {
    const lines = [];
    this.setState({ fetchingLines: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("lines")
      .get()
      .then((lineSnapshot) => {
        if (!lineSnapshot.empty) {
          lineSnapshot.forEach((line) =>
            lines.push({
              value: line.id,
              label: `${line.data().name}`,
            })
          );
          this.setState({ fetchingLines: false, lines });
        } else {
          this.setState({ fetchingLines: false, lines });
        }
      })
      .catch((e) => console.log(e));
  };

  _fetchTables = () => {
    const tables = [];
    this.setState({ fetchingTables: true });
    db.collection("companies")
      .doc(this.props.companyID)
      .collection("tables")
      .get()
      .then((tableSnapshot) => {
        if (!tableSnapshot.empty) {
          tableSnapshot.forEach((table) =>
            tables.push({
              value: table.id,
              label: `${table.data().name}`,
            })
          );
          this.setState({ fetchingTables: false, tables });
        } else {
          this.setState({ fetchingTables: false, tables });
        }
      })
      .catch((e) => console.log(e));
  };

  //handlers
  _handleCancel = () => {
    this.props.reset(); //form reset - redux-form action creator
    this.props.handleCancel(); //function passed via props
  };

  _handlePlaceholder = (stateProperty) => (stateFetch) => (gender) => {
    if (stateFetch) {
      return "Aguarde";
    }

    if (!stateFetch && !stateProperty.length) {
      return `Nenhum${gender === "male" ? "" : "a"} cadastrad${
        gender === "male" ? "o" : "a"
      }`;
    }

    if (!stateFetch && stateProperty.length) {
      return "Selecione";
    }
  };
}

ScreenForm = reduxForm({ form: "ScreenForm", validate })(ScreenForm);
export default ScreenForm;



// WEBPACK FOOTER //
// ./src/forms/ScreenForm.jsx